/* eslint-disable react/display-name */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import High_risk from "@/resource/images/svg/diseaseMap/high_risk.svg";
import IF from "@/components/IF";
interface IMarkerProps{
    text?: string;
    lng?: number;
    lat?: number;
    height: number;
    width: number;
    riskLevel?: string;
    disease?: string;
}

const DiseaseMarker = (prop: IMarkerProps) => {

    const {
        lng,
        lat,
        text,
        height,
        width,
        riskLevel,
        disease
    } = prop;
    return (
        <div
            onMouseOver={()=>{
                console.log(`lng: ${lng}, lat: ${lat}`);
            }}
            style={{
                position: "relative",
                // marginLeft:`-${width}px`
                top: `-${height}px`,
                left: `-${width/2}px`
            }}
        >
            {/* basic Risk */}
            <IF show = {disease !== "SoilTemperatureRisk"}>
                <IF show={riskLevel === "NO"}>
                    <Now_risk_Svg height={height} width={width}/>
                </IF>
                <IF show={riskLevel === "LOW"}>
                    <Low_risk_Svg height={height} width={width}/>
                </IF>
                <IF show={riskLevel === "MEDIUM"}>
                    <Medium_risk_Svg height={height} width={width}/>
                </IF>
                <IF show={riskLevel === "HIGH"}>
                    <High_risk_Svg height={height} width={width}/>
                </IF>
                <IF show={riskLevel === "VERYHITH"}>
                    <Very_High_risk_Svg height={height} width={width}/>
                </IF>
            </IF>
            {/* Soil Temperature Risk */}
            <IF show = {disease === "SoilTemperatureRisk"}>
                <IF show={riskLevel === "NO"}>
                    <SoilRiskSvg height={height} width={width} color="#320097"/>
                </IF>
                <IF show={riskLevel === "LOW"}>
                    <SoilRiskSvg height={height} width={width} color="#01f3ff40"/>
                </IF>
                <IF show={riskLevel === "MEDIUM"}>
                    <SoilRiskSvg height={height} width={width} color="#00FEF6"/>
                </IF>
                <IF show={riskLevel === "HIGH"}>
                    <SoilRiskSvg height={height} width={width} color="#66F196"/>
                </IF>
                <IF show={riskLevel === "VERYHITH"}>
                    <SoilRiskSvg height={height} width={width} color="#FFDB00"/>
                </IF>
                <IF show={riskLevel === "SOHITH"}>
                    <SoilRiskSvg height={height} width={width} color="#FF7903"/>
                </IF>
            </IF>
        </div>
    );
};
export default React.memo(DiseaseMarker);


// map zoom seeting



interface ISvgProps{
    width: number;
    height: number;
}

const Now_risk_Svg = React.memo((props:ISvgProps)=>{
    const {width,height} = props;

    return(
        <svg width={width} height={height} viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0765 42.153C7.36274 39.5959 1 31.541 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22C43 31.541 36.6373 39.5959 27.9235 42.153L22.8944 52.2111C22.5259 52.9482 21.4741 52.9482 21.1056 52.2111L16.0765 42.153Z" fill="white"/>
            <path d="M16.0765 42.153L16.5237 41.9294L16.4263 41.7345L16.2173 41.6732L16.0765 42.153ZM27.9235 42.153L27.7827 41.6732L27.5737 41.7345L27.4763 41.9294L27.9235 42.153ZM21.1056 52.2111L20.6584 52.4348L21.1056 52.2111ZM16.2173 41.6732C7.71067 39.1769 1.5 31.3131 1.5 22H0.5C0.5 31.7689 7.01481 40.0149 15.9357 42.6327L16.2173 41.6732ZM1.5 22C1.5 10.6782 10.6782 1.5 22 1.5V0.5C10.1259 0.5 0.5 10.1259 0.5 22H1.5ZM22 1.5C33.3218 1.5 42.5 10.6782 42.5 22H43.5C43.5 10.1259 33.8741 0.5 22 0.5V1.5ZM42.5 22C42.5 31.3131 36.2893 39.1769 27.7827 41.6732L28.0643 42.6327C36.9852 40.0149 43.5 31.7689 43.5 22H42.5ZM23.3416 52.4348L28.3707 42.3766L27.4763 41.9294L22.4472 51.9875L23.3416 52.4348ZM20.6584 52.4348C21.2111 53.5403 22.7889 53.5403 23.3416 52.4348L22.4472 51.9875C22.263 52.3561 21.737 52.3561 21.5528 51.9875L20.6584 52.4348ZM15.6293 42.3766L20.6584 52.4348L21.5528 51.9875L16.5237 41.9294L15.6293 42.3766Z" fill="black" fillOpacity="0.4"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z" fill="#23F900" stroke="black" strokeOpacity="0.4"/>
        </svg>
    );
});

const Low_risk_Svg = React.memo((props:ISvgProps)=>{
    const {width,height} = props;

    return(
        <svg width={width} height={height} viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0765 42.153C7.36274 39.5959 1 31.541 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22C43 31.541 36.6373 39.5959 27.9235 42.153L22.8944 52.2111C22.5259 52.9482 21.4741 52.9482 21.1056 52.2111L16.0765 42.153Z" fill="white"/>
            <path d="M16.0765 42.153L16.5237 41.9294L16.4263 41.7345L16.2173 41.6732L16.0765 42.153ZM27.9235 42.153L27.7827 41.6732L27.5737 41.7345L27.4763 41.9294L27.9235 42.153ZM21.1056 52.2111L20.6584 52.4348L21.1056 52.2111ZM16.2173 41.6732C7.71067 39.1769 1.5 31.3131 1.5 22H0.5C0.5 31.7689 7.01481 40.0149 15.9357 42.6327L16.2173 41.6732ZM1.5 22C1.5 10.6782 10.6782 1.5 22 1.5V0.5C10.1259 0.5 0.5 10.1259 0.5 22H1.5ZM22 1.5C33.3218 1.5 42.5 10.6782 42.5 22H43.5C43.5 10.1259 33.8741 0.5 22 0.5V1.5ZM42.5 22C42.5 31.3131 36.2893 39.1769 27.7827 41.6732L28.0643 42.6327C36.9852 40.0149 43.5 31.7689 43.5 22H42.5ZM23.3416 52.4348L28.3707 42.3766L27.4763 41.9294L22.4472 51.9875L23.3416 52.4348ZM20.6584 52.4348C21.2111 53.5403 22.7889 53.5403 23.3416 52.4348L22.4472 51.9875C22.263 52.3561 21.737 52.3561 21.5528 51.9875L20.6584 52.4348ZM15.6293 42.3766L20.6584 52.4348L21.5528 51.9875L16.5237 41.9294L15.6293 42.3766Z" fill="black" fillOpacity="0.25"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z" fill="#FAFF00" stroke="black" strokeOpacity="0.25"/>
        </svg>

    );
});

const Medium_risk_Svg = React.memo((props:ISvgProps)=>{
    const {width,height} = props;

    return(
        <svg width={width} height={height} viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0765 42.153C7.36274 39.5959 1 31.541 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22C43 31.541 36.6373 39.5959 27.9235 42.153L22.8944 52.2111C22.5259 52.9482 21.4741 52.9482 21.1056 52.2111L16.0765 42.153Z" fill="white"/>
            <path d="M16.0765 42.153L16.5237 41.9294L16.4263 41.7345L16.2173 41.6732L16.0765 42.153ZM27.9235 42.153L27.7827 41.6732L27.5737 41.7345L27.4763 41.9294L27.9235 42.153ZM21.1056 52.2111L20.6584 52.4348L21.1056 52.2111ZM16.2173 41.6732C7.71067 39.1769 1.5 31.3131 1.5 22H0.5C0.5 31.7689 7.01481 40.0149 15.9357 42.6327L16.2173 41.6732ZM1.5 22C1.5 10.6782 10.6782 1.5 22 1.5V0.5C10.1259 0.5 0.5 10.1259 0.5 22H1.5ZM22 1.5C33.3218 1.5 42.5 10.6782 42.5 22H43.5C43.5 10.1259 33.8741 0.5 22 0.5V1.5ZM42.5 22C42.5 31.3131 36.2893 39.1769 27.7827 41.6732L28.0643 42.6327C36.9852 40.0149 43.5 31.7689 43.5 22H42.5ZM23.3416 52.4348L28.3707 42.3766L27.4763 41.9294L22.4472 51.9875L23.3416 52.4348ZM20.6584 52.4348C21.2111 53.5403 22.7889 53.5403 23.3416 52.4348L22.4472 51.9875C22.263 52.3561 21.737 52.3561 21.5528 51.9875L20.6584 52.4348ZM15.6293 42.3766L20.6584 52.4348L21.5528 51.9875L16.5237 41.9294L15.6293 42.3766Z" fill="black" fillOpacity="0.25"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z" fill="#FFB800" stroke="black" strokeOpacity="0.25"/>
        </svg>

    );
});

const High_risk_Svg = React.memo((props:ISvgProps)=>{
    const {width,height} = props;

    return(
        <svg width={width} height={height} viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0765 42.153C7.36274 39.5959 1 31.541 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22C43 31.541 36.6373 39.5959 27.9235 42.153L22.8944 52.2111C22.5259 52.9482 21.4741 52.9482 21.1056 52.2111L16.0765 42.153Z" fill="white"/>
            <path d="M16.0765 42.153L16.5237 41.9294L16.4263 41.7345L16.2173 41.6732L16.0765 42.153ZM27.9235 42.153L27.7827 41.6732L27.5737 41.7345L27.4763 41.9294L27.9235 42.153ZM21.1056 52.2111L20.6584 52.4348L21.1056 52.2111ZM16.2173 41.6732C7.71067 39.1769 1.5 31.3131 1.5 22H0.5C0.5 31.7689 7.01481 40.0149 15.9357 42.6327L16.2173 41.6732ZM1.5 22C1.5 10.6782 10.6782 1.5 22 1.5V0.5C10.1259 0.5 0.5 10.1259 0.5 22H1.5ZM22 1.5C33.3218 1.5 42.5 10.6782 42.5 22H43.5C43.5 10.1259 33.8741 0.5 22 0.5V1.5ZM42.5 22C42.5 31.3131 36.2893 39.1769 27.7827 41.6732L28.0643 42.6327C36.9852 40.0149 43.5 31.7689 43.5 22H42.5ZM23.3416 52.4348L28.3707 42.3766L27.4763 41.9294L22.4472 51.9875L23.3416 52.4348ZM20.6584 52.4348C21.2111 53.5403 22.7889 53.5403 23.3416 52.4348L22.4472 51.9875C22.263 52.3561 21.737 52.3561 21.5528 51.9875L20.6584 52.4348ZM15.6293 42.3766L20.6584 52.4348L21.5528 51.9875L16.5237 41.9294L15.6293 42.3766Z" fill="black" fillOpacity="0.25"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z" fill="#FF6B00" stroke="black" strokeOpacity="0.25"/>
        </svg>

    );
});

const Very_High_risk_Svg = React.memo((props:ISvgProps)=>{
    const {width,height} = props;

    return(
        <svg width={width} height={height} viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0765 42.153C7.36274 39.5959 1 31.541 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22C43 31.541 36.6373 39.5959 27.9235 42.153L22.8944 52.2111C22.5259 52.9482 21.4741 52.9482 21.1056 52.2111L16.0765 42.153Z" fill="white"/>
            <path d="M16.0765 42.153L16.5237 41.9294L16.4263 41.7345L16.2173 41.6732L16.0765 42.153ZM27.9235 42.153L27.7827 41.6732L27.5737 41.7345L27.4763 41.9294L27.9235 42.153ZM21.1056 52.2111L20.6584 52.4348L21.1056 52.2111ZM16.2173 41.6732C7.71067 39.1769 1.5 31.3131 1.5 22H0.5C0.5 31.7689 7.01481 40.0149 15.9357 42.6327L16.2173 41.6732ZM1.5 22C1.5 10.6782 10.6782 1.5 22 1.5V0.5C10.1259 0.5 0.5 10.1259 0.5 22H1.5ZM22 1.5C33.3218 1.5 42.5 10.6782 42.5 22H43.5C43.5 10.1259 33.8741 0.5 22 0.5V1.5ZM42.5 22C42.5 31.3131 36.2893 39.1769 27.7827 41.6732L28.0643 42.6327C36.9852 40.0149 43.5 31.7689 43.5 22H42.5ZM23.3416 52.4348L28.3707 42.3766L27.4763 41.9294L22.4472 51.9875L23.3416 52.4348ZM20.6584 52.4348C21.2111 53.5403 22.7889 53.5403 23.3416 52.4348L22.4472 51.9875C22.263 52.3561 21.737 52.3561 21.5528 51.9875L20.6584 52.4348ZM15.6293 42.3766L20.6584 52.4348L21.5528 51.9875L16.5237 41.9294L15.6293 42.3766Z" fill="black" fillOpacity="0.25"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z" fill="#FF0000" stroke="black" strokeOpacity="0.25"/>
        </svg>

    );
});

interface IRiskProp{
    color: string;
    width: number;
    height: number;
}
const SoilRiskSvg = (prop:IRiskProp)=>{
    const {color,width,height} = prop;
    return(
        <svg width={width} height={height} viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0765 42.153C7.36274 39.5959 1 31.541 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22C43 31.541 36.6373 39.5959 27.9235 42.153L22.8944 52.2111C22.5259 52.9482 21.4741 52.9482 21.1056 52.2111L16.0765 42.153Z" fill="white"/>
            <path d="M16.0765 42.153L16.5237 41.9294L16.4263 41.7345L16.2173 41.6732L16.0765 42.153ZM27.9235 42.153L27.7827 41.6732L27.5737 41.7345L27.4763 41.9294L27.9235 42.153ZM21.1056 52.2111L20.6584 52.4348L21.1056 52.2111ZM16.2173 41.6732C7.71067 39.1769 1.5 31.3131 1.5 22H0.5C0.5 31.7689 7.01481 40.0149 15.9357 42.6327L16.2173 41.6732ZM1.5 22C1.5 10.6782 10.6782 1.5 22 1.5V0.5C10.1259 0.5 0.5 10.1259 0.5 22H1.5ZM22 1.5C33.3218 1.5 42.5 10.6782 42.5 22H43.5C43.5 10.1259 33.8741 0.5 22 0.5V1.5ZM42.5 22C42.5 31.3131 36.2893 39.1769 27.7827 41.6732L28.0643 42.6327C36.9852 40.0149 43.5 31.7689 43.5 22H42.5ZM23.3416 52.4348L28.3707 42.3766L27.4763 41.9294L22.4472 51.9875L23.3416 52.4348ZM20.6584 52.4348C21.2111 53.5403 22.7889 53.5403 23.3416 52.4348L22.4472 51.9875C22.263 52.3561 21.737 52.3561 21.5528 51.9875L20.6584 52.4348ZM15.6293 42.3766L20.6584 52.4348L21.5528 51.9875L16.5237 41.9294L15.6293 42.3766Z" fill="black" fillOpacity="0.25"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z" fill={color} stroke="black" strokeOpacity="0.25"/>
        </svg>
    );
};